import { render, staticRenderFns } from "./ReferralDebiting.vue?vue&type=template&id=8171c8d4&lang=pug"
import script from "./ReferralDebiting.vue?vue&type=script&lang=js"
export * from "./ReferralDebiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports